import { FieldTypes } from '../../../../helpers/constants';
import { TemplateField } from '../../../../types/template-types';

/**
 * Validates if the selected fields are checkboxes
 */
export function validateFieldsAreCheckboxes(checkboxFields: TemplateField[]): boolean {
  return checkboxFields.every((field) => field?.type === FieldTypes.CheckBox);
}
